import styled from 'styled-components'
import { Affix } from 'react-overlays'
import OSSearchInput from 'containers/Osearch/SearchInput'
import ESSearchInput from 'containers/ESSearch/SearchInput'
import FootprintsSearch from 'containers/Footprints/Search'
import KendraInput from 'containers/Kendra/searchBar/SearchInput'
import {
  DeviceSearchContainer,
  NotesContainer,
  CallHandlerContainer
} from 'containers'

const SearchWrapper = styled.div`
  min-height: 86px;
`

const Cell = styled.div`
  width: 30%;

  @media only screen and (max-width: 768px) {
    margin-right: 0px !important;
    margin-left: 0px !important;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 90%;
  }
`

const Container = styled.div`
  background: var(--main-color);
  z-index: 701;
  width: 100%;
  display: flex;
  padding: 15px;
  align-items: center;
  min-height: 86px;

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
    justify-content: center;
  }
`

/**
 * Subheader component that displays different search inputs and containers
 * based on the props. The component uses the `Affix` component from
 * `react-overlays` to make the header section sticky at the top of the viewport.
 *
 * The `Subheader` component is the default export of the file, and is the main
 * entry to the search subheader containers.
 *
 * @param {Object} props - The props object containing the following properties:
 * @param {boolean} props.showNotes - A boolean value indicating whether to show
 *    the Notes container.
 * @param {boolean} props.showCallHandler - A boolean value indicating whether
 *    to show the call handler container.
 * @param {string} props.location - The current location of the application.
 * @param {boolean} props.isKendraEnabled - A boolean value indicating whether
 *    Kendra is enabled.
 * @returns {JSX.Element}
 * @constructor
 */
const Subheader = ({
  showNotes,
  showCallHandler,
  location,
  isKendraEnabled,
  getOption,
  ...props
}) => {
  const searchEngine = getOption('search.searchEngine', '')
  const showDeviceSearch =
    !isKendraEnabled && location !== '/' && location !== '/search'

  const renderSearchInput = () => {
    /*
      Render the appropriate search input based on the selected search engine and Kendra status.
      - If searchEngine is 'osearch', show the default SearchInput.
      - If Kendra is enabled, show the KendraInput.
      - Otherwise, show the ESSearchInput.
    */
    if (searchEngine === 'osearch') {
      // Show default search input for 'ossearch' engine
      return <OSSearchInput />
    } else if (isKendraEnabled) {
      // Show Kendra search input if Kendra is enabled
      return <KendraInput />
    } else {
      // Fallback to ES search input
      return <ESSearchInput />
    }
  }

  return (
    <SearchWrapper>
      <Affix offsetTop={60} viewportOffsetTop={0}>
        <Container>
          <>
            <Cell style={{ marginRight: '10px' }}>{renderSearchInput()}</Cell>
            <FootprintsSearch />
          </>
          {showNotes && <NotesContainer />}
          {showCallHandler && <CallHandlerContainer />}
          {showDeviceSearch && (
            <Cell style={{ marginLeft: 'auto' }}>
              <DeviceSearchContainer />
            </Cell>
          )}
        </Container>
      </Affix>
    </SearchWrapper>
  )
}

export default Subheader
